// src/components/FWI/FWIZonesLayer.js
import { useMemo, Fragment } from 'react';
import { Source, Layer } from 'react-map-gl/mapbox';
import useGetFWIZones from '../../../hooks/useGetFWIZones';

const FWIZonesLayer = ({ visible = true }) => {
  const { zones, error } = useGetFWIZones(visible);

  const fillPaint = useMemo(() => ({
    'fill-color': [
      'case',
      ['==', ['get', 'riskIndex'], 1], 'green',
      ['==', ['get', 'riskIndex'], 2], 'yellow',
      ['==', ['get', 'riskIndex'], 3], 'orange',
      ['==', ['get', 'riskIndex'], 4], 'red',
      '#9ca3af'
    ],
    'fill-opacity': 0.35
  }), []);

  const linePaint = useMemo(() => ({
    'line-color': '#ffffff',
    'line-width': 1
  }), []);

  if (!visible) return null;
  if (error) return <div style={{ position: 'absolute', top: 10, right: 10, background: '#fee2e2', color: '#991b1b', padding: 8, borderRadius: 4, zIndex: 2 }}>{error}</div>;
  if (!zones) return null;

  return (
    <Fragment>
      <Source id="fwi-zones" type="geojson" data={zones} generateId={true}>
        <Layer id="fwi-zones-fill" type="fill" paint={fillPaint} />
        <Layer id="fwi-zones-outline" type="line" paint={linePaint} />
      </Source>
    </Fragment>
  );
};

export default FWIZonesLayer;
